import React from 'react'
function FromRating(props) {
  const { changeCategoryRating, Ratingvalue, statusType } = props
  const ratingArray = [0, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5]
  //
  return (
    <div>
      <select
        style={{ width: '5rem' }}
        className='selectWidth'
        disabled={statusType === 'draft'}
        defaultValue={'desc'}
        value={Ratingvalue}
        onChange={e => changeCategoryRating(e)}
        required
        name='select'
        id='languages'
      >
        <option value='' disabled selected>
          Age Restriction
        </option>
        {ratingArray.map((item, index) => (
          <option key={index} value={item} selected={Ratingvalue === item}>
            {item}
          </option>
        ))}
      </select>
    </div>
  )
}

export default FromRating
